import * as React from 'react';

const TwitterIcon = (props) => (
    <svg width={30} height={30} fill="none" {...props}>
        <path fill="#03A9F4" d="M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15Z" />
        <path
            fill="#fff"
            d="M24 9.658a7.181 7.181 0 0 1-2.009.559 3.503 3.503 0 0 0 1.534-1.953c-.683.41-1.431.7-2.21.855a3.474 3.474 0 0 0-1.781-1.033 3.443 3.443 0 0 0-2.046.161c-.651.26-1.21.713-1.602 1.3a3.564 3.564 0 0 0-.603 1.987c-.002.27.025.54.081.805a9.772 9.772 0 0 1-3.982-1.07 9.898 9.898 0 0 1-3.204-2.624c-.45.778-.589 1.7-.39 2.578.2.878.723 1.646 1.462 2.147a3.407 3.407 0 0 1-1.575-.436v.039c.002.815.28 1.604.789 2.236a3.495 3.495 0 0 0 2.004 1.232c-.298.08-.605.118-.914.115a3.073 3.073 0 0 1-.661-.06c.226.702.66 1.315 1.244 1.755.583.44 1.287.687 2.015.706A6.953 6.953 0 0 1 7 20.415 9.715 9.715 0 0 0 12.354 22c6.416 0 9.924-5.384 9.924-10.051 0-.156 0-.306-.012-.457.683-.5 1.27-1.12 1.734-1.834Z"
        />
    </svg>
);

export default TwitterIcon;
